export const UTB_REPORT_CONTAINER_CLASS = 'utb-report-container';

export const UTB_REPORT_FONT_FAMILY = 'Arial, Helvetica, sans-serif';

// Applied inline on the report Container so the font/background match in both the
// on-screen preview (React) and the server-side PDF (renderToStaticMarkup), without
// depending on any external stylesheet being injected on the consumer side.
export const UTB_REPORT_CONTAINER_STYLE = {
  boxSizing: 'border-box' as const,
  position: 'relative' as const,
  width: '100%',
  top: 0,
  fontFamily: UTB_REPORT_FONT_FAMILY,
  backgroundColor: 'white',
};

export const UTB_REPORT_CSS = `
.${UTB_REPORT_CONTAINER_CLASS} {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  top: 0;
  font-family: ${UTB_REPORT_FONT_FAMILY};
  background-color: white;
}
`;
